webpackJsonp([241519746402832],{

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Architecture = __webpack_require__(28);
	
	var _Architecture2 = _interopRequireDefault(_Architecture);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Architecture2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Infinite Scrolling: Architecture'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Challenge when implementing infinite scrolling and architectural approach Lore uses to address it.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Challenge'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The core challenge here is recognizing that Infinite Scrolling is primarily a view concern, in that it\'s exactly the same as traditional pagination except for how the data is displayed to the user.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Implementation'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Since Infinite Scrolling shares the same infrastructure as traditional pagination, please see ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/features/pagination/' },
	        'Pagination'
	      ),
	      ' for a description of how to implement support for it.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-architecture-features-infinite-scrolling-js-5b8ae570241a381a580c.js